import http from 'utils/http';
import API from 'utils/API';

export type PlatformType = 'darwin' | 'win32'; // mac | windows

export function getDownloadPcLink(platform: PlatformType) {
    return http.get<{
        downloadUrl: string;
    }>(API.UPPLAY.getDownloadPcLink(), {
        params: {
            appVer: 0,
            appName: 'tradeup',
            platform
        },
        noToken: true // 请求下载链接 不需要传入token，且up域名下的都会指向国内 用美国的token会报错
    });
}
